<template>
	<div class="travel-type-switch">
		<ChipBase
			v-model="offerType"
			:label="LABELS.PACKAGE"
			:icon-name="'package'"
			:as="'radio'"
			value="PACKAGE"
			:ga-item-id="LABELS.PACKAGE"
			ga-content-type="ux_traveltype_switch"
			@analytics-event="handleAnalyticsEvent"
		>
			<template #icon>
				<PackageIcon />
			</template>
		</ChipBase>
		<ChipBase
			v-model="offerType"
			:label="LABELS.HOTEL_ONLY"
			:icon-name="'room2'"
			value="HOTEL_ONLY"
			:as="'radio'"
			:ga-item-id="LABELS.HOTEL_ONLY"
			ga-content-type="ux_traveltype_switch"
			@analytics-event="handleAnalyticsEvent"
		>
			<template #icon>
				<FaIcon :icon="['fa-solid', 'fa-bed']" />
			</template>
		</ChipBase>
		<ChipBase
			v-if="showCruiseTab"
			:label="LABELS.CRUISE"
			:as="'link'"
			:ga-item-id="LABELS.CRUISE"
			ga-content-type="ux_traveltype_switch"
			@click="goToCruisePage"
			@analytics-event="handleAnalyticsEvent"
		>
			<template #icon>
				<FaIcon :icon="['fa-solid', 'fa-ship']" />
			</template>
			<template #suffix-icon>
				<FaIcon
					:icon="['fa-solid', 'fa-arrow-right']"
					class="suffix-icon-cruise"
				/>
			</template>
		</ChipBase>
	</div>
</template>
<script setup lang="ts">
import ChipBase from '@lmt-rpb/Atoms/ChipBase/ChipBase.vue';
import { useStore } from '@store/index';
import { computed } from 'vue';
import FaIcon from '@lmt-rpb/Atoms/FaIcon/FaIcon.vue';
import PackageIcon from './internals/PackageIcon.vue';
import { useTranslations } from '@helper/composables/translations';
import { getClientString, getCruisePage } from '@utils/environmentUtils';
import ChipAnalytics from '@/js/modules/analytics/ChipAnalytics';

const store = useStore();
const { translate } = useTranslations();

const LABELS = computed(() => ({
	PACKAGE: translate('searchBarMain.travelType.package'),
	HOTEL_ONLY: translate('searchBarMain.travelType.hotelOnly'),
	CRUISE: translate('searchBarMain.travelType.cruise'),
}));

const showCruiseTab = computed(() => getClientString() === 'rpb_at' && store.state.config.pageType === 'homePage');

const goToCruisePage = () => {
	window.open(getCruisePage(), '_blank')?.focus();
};

const offerType = computed({
	get() {
		return store.state.searchMask.onlyHotel ? 'HOTEL_ONLY' : 'PACKAGE';
	},
	set(newValue) {
		const onlyHotel = newValue === 'HOTEL_ONLY';
		store.commit('searchMask/updateFormData', { onlyHotel });
	},
});

const handleAnalyticsEvent = (event: { event: string; contentType: string; contentId: string }) => {
	ChipAnalytics.createInstance(event).fireChipSelected();
};
</script>
<style scoped lang="scss">
.travel-type-switch {
	display: flex;
	gap: 0.8rem;

	& > * {
		flex-shrink: 0;
	}

	.suffix-icon {
		margin-right: 0;

		&-cruise {
			font-size: $font-small-1;
		}
	}
}
</style>
